import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=4c802f61&scoped=true&"
import script from "./OrderStatus.vue?vue&type=script&lang=js&"
export * from "./OrderStatus.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatus.vue?vue&type=style&index=0&id=4c802f61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c802f61",
  null
  
)

export default component.exports